<script setup>
const { t } = useI18n();
const route = useRoute();
const setI18nParams = useSetI18nParams();
const gtm = useGtm();

import { pageTransition } from '~/helpers/animations/animations';
definePageMeta({
  pageTransition: pageTransition,
});

const who = ref('');

const breadcrumbs = ref([{ title: t('pages.club.index.title'), route: 'club' }, { title: t('pages.club.buy.breadcrumbs-title') }]);

const setWho = (forWhom) => {
  who.value = forWhom;
};

const cards = ref([
  {
    id: 'card1',
    slug: 'pritel',
    name: t('assets.data.cards-1-name'),
    price: 1150,
    image: '/img/club/friend.png',
    points: t('assets.data.cards-1-points'),
    link: true,
    type: 'friend',
  },
  {
    id: 'card2',
    slug: 'pritel-plus',
    name: t('assets.data.cards-2-name'),
    price: 1750,
    image: '/img/club/friend-plus.png',
    points: t('assets.data.cards-2-points'),
    link: true,
    type: 'friend-plus',
  },
  {
    id: 'card3',
    slug: 'junior',
    name: t('assets.data.cards-3-name'),
    price: 650,
    image: '/img/club/junior.png',
    points: t('assets.data.cards-3-points'),
    link: true,
    type: 'junior',
  },
  {
    id: 'card4',
    slug: 'senior',
    name: t('assets.data.cards-4-name'),
    price: 550,
    image: '/img/club/senior.png',
    points: t('assets.data.cards-4-points'),
    link: true,
    type: 'senior',
  },
  {
    id: 'card5',
    slug: 'podporovatel',
    name: t('assets.data.cards-5-name'),
    price: 5000,
    image: '/img/club/supporter.png',
    points: t('assets.data.cards-5-points'),
    link: true,
    type: 'podporovatel',
  },
]);

const card = cards.value.find((card) => card.slug === route.params.slug);

onMounted(() => {
  if (process.browser) {
    const goOutScript = document.createElement('script');
    goOutScript.setAttribute('src', 'https://partners.goout.net/cz-prague/ngpraguecz_new.js');
    goOutScript.async = true;
    goOutScript.onload = () => {
      console.log('GoOut script loaded');
      document.dispatchEvent(new Event('page-refreshed'));
    };
    document.body.appendChild(goOutScript);
  } else {
    console.log('GoOut script already exists');
    document.dispatchEvent(new Event('page-refreshed'));
  }

  gtm.trackEvent({
    event: 'club_step1',
    description: card.name,
    url: window.location.href.replace(window.location.origin, ''),
  });
});

onBeforeUnmount(() => {
  if (document.querySelector('#goout')) {
    document.querySelector('#goout').removeAttribute('id');
  }
});

setI18nParams({
  en: {
    slug: card?.value?.slug?.en,
  },
  cs: {
    slug: card?.value?.slug?.cs,
  },
});
</script>

<template>
  <main class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <h1 class="heading">{{ t('pages.club.index.title') }}</h1>
    <div v-if="card" class="container-content mt-5">
      <h2 class="heading heading--2 heading--thin mt-5">
        {{ t('pages.club.buy.selected-type') }}
      </h2>

      <ClubCardSingle :name="card.name" :price="card.price" :image="useGetImageUrl(card.image, 420)" :warning="card.warning" selected class="mt-5">
        <ul class="list" v-html="card.points" />
      </ClubCardSingle>

      <div class="form-button-group mt-4">
        <div :class="{ 'is-active': who === 'forMyself' }" class="form-button-group__item forMyself" @click="setWho('forMyself')">
          {{ t('pages.club.buy.switcher-1') }}
        </div>
        <div :class="{ 'is-active': who === 'renew' }" class="form-button-group__item renew" @click="setWho('renew')">
          {{ t('pages.club.buy.switcher-3') }}
        </div>
        <div :class="{ 'is-active': who === 'forOther' }" class="form-button-group__item forOther" @click="setWho('forOther')">
          {{ t('pages.club.buy.switcher-2') }}
        </div>
      </div>
      <div id="goout"></div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.form-button-group {
  @include mq($lg) {
    display: flex;
  }

  &__item {
    width: 100%;
    padding: 20px;
    border: 1px solid $black;
    text-align: center;
    cursor: pointer;

    @include mq($lg, true) {
      &:nth-child(n + 2) {
        border-top: none;
      }
    }

    @include mq($lg) {
      // width: 300px;

      &:nth-child(n + 2) {
        border-left: none;
      }
    }

    &.is-active {
      background-color: $black;
      color: $white;
    }

    &.disabled {
      cursor: default;
      color: $silver;
      border-color: $silver;
      background-color: transparent;
    }
  }
}
</style>
